var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatherEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.157 2.68652H2.59C2.16831 2.68652 1.76388 2.85404 1.4657 3.15222C1.16752 3.45041 1 3.85483 1 4.27652V15.4095C1 15.8312 1.16752 16.2356 1.4657 16.5338C1.76388 16.832 2.16831 16.9995 2.59 16.9995H13.723C14.1447 16.9995 14.5491 16.832 14.8473 16.5338C15.1455 16.2356 15.313 15.8312 15.313 15.4095V9.84352",
    stroke: "rgba(0, 0, 0, 0.85)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1215 1.49351C14.4382 1.17724 14.8675 0.999719 15.315 1C15.7626 1.00028 16.1917 1.17834 16.508 1.49501C16.8243 1.81168 17.0018 2.24102 17.0015 2.68857C17.0012 3.13613 16.8232 3.56524 16.5065 3.88151L8.95248 11.4355L5.77148 12.2355L6.57148 9.05451L14.1215 1.49351Z",
    stroke: "rgba(0, 0, 0, 0.85)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherEdit);
export default __webpack_public_path__ + "static/media/feather-edit.4ce2c932e942f8a5f54008408fcc7405.svg";
export { ForwardRef as ReactComponent };